import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { FindingState } from "@p0security/shared/types/assessment/finding";
import { startCase } from "lodash";
import React from "react";

export const FindingsIconLabel: React.FC<{
  children: React.ReactNode;
  icon: React.ReactNode;
}> = ({ children, icon }) => (
  <span className="inline-flex items-center gap-1.5">
    {icon}
    {children}
  </span>
);

const findingStateIcon = (state: (typeof FindingState)[number]) =>
  state === "open" ? (
    <span
      aria-hidden
      className="inline-block h-3 w-3 rounded-full border-[1.5px] border-solid border-current"
    />
  ) : state === "ignored" ? (
    <CloseCircleOutlined />
  ) : (
    <CheckCircleOutlined />
  );

export const findingStateLabelFor = (state: (typeof FindingState)[number]) => (
  <FindingsIconLabel icon={findingStateIcon(state)}>
    {startCase(state)}
  </FindingsIconLabel>
);

export const UnassignedLabel: React.FC = () => (
  <FindingsIconLabel icon={<UserAddOutlined />}>Unassigned</FindingsIconLabel>
);
